import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const fallbackTimeout = setTimeout(() => {
      console.warn('Turbo.visit fallback triggered, using full reload.');
      window.location.reload();
    }, 2000); // fallback after 2s if Turbo doesn't work

    // Listen for Turbo navigation starting, then cancel fallback
    const handleVisit = () => {
      clearTimeout(fallbackTimeout);
      window.removeEventListener('turbo:visit', handleVisit);
    };

    window.addEventListener('turbo:visit', handleVisit);

    try {
      window.Turbo.visit(window.location.href);
    } catch (e) {
      console.error('Turbo.visit threw an error, using full reload:', e);
      clearTimeout(fallbackTimeout);
      window.removeEventListener('turbo:visit', handleVisit);
      window.location.reload();
    }
  }
}
